module.exports = __webpack_public_path__ + "vietnam.svg?c4f7fdb3afc07ee3504d1144456fe514";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/vietnam.svg
// module id = 339
// module chunks = 10